import React, { useEffect, useState } from "react";
import { Card, Button, Input, Space, Collapse, Form } from "antd";
import { Button as ButtonAntd } from "antd";
import {
  EyeOutlined,
  ReloadOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { TagContainer } from "./Tags.style";
import { CustomTag } from "./interface";
import { addNewTag, addTag3D, getTagList, removeAllTagAnnotationsFrom3D, removeTag, setAddNewTagBool, zoomToTag } from "./tagUtils";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AddTag from "./AddTag";
const { Panel } = Collapse;

interface TagsProps {
  setActiveMenu : (menuId: string | null) => void;
}
export default function Tags({ setActiveMenu }: TagsProps) {
  const [showNewTag, setShowNewTag] = useState(false);
  const [tags, setTags] = useState<CustomTag[]>([]);
  const [editTag, setEditTag] = useState<CustomTag | null>(null);
  const [activePanel, setActivePanel] = useState<string | null>(null);
  const loadTags = () => {
    const tags = getTagList();

    const visibleDataIds = window.potreeViewer.scene.pointclouds.map((e: any) => e.data_id)
    const filteredTags = tags.filter((tag) => {
      return tag.dataIds.some((dataId) => visibleDataIds.includes(dataId));
    });

    removeAllTagAnnotationsFrom3D();

    filteredTags.forEach((tag) => {
      addTag3D(tag);
    });
    setTags(filteredTags);
  }

  useEffect(() => {
    loadTags();
  }, []);


  const handleNewTag = () => {
    const tagList = getTagList();
    let tagIds = tagList.map((tag) => parseInt(tag.id));
    tagIds = tagIds.filter((id) => !isNaN(id));
    setShowNewTag(true);
    setAddNewTagBool(true);
  }

  const handleCancel = () => {
    setShowNewTag(false);
    setEditTag(null);
  };

  const handleDelete = (id: string) => {
    removeTag(id);
    setTags(tags.filter((tag) => tag.id !== id));
  }

  const handleSave = (newTag: CustomTag) => {
    setShowNewTag(false);
    if (editTag) {
      setTags(tags.map(tag => (tag.id === newTag.id ? newTag : tag)));
      setEditTag(null);
    } else {
      setTags([...tags, newTag]);
    }
  };

  const handleEdit = (tag: CustomTag) => {
    if (editTag && editTag.id === tag.id) {
      setActivePanel(null);
      setEditTag(null);
    } else {
      setEditTag(tag); 
      setShowNewTag(false); 
      setActivePanel(tag.id);
    }
  };

  const handlePanelTitleClick = (itemId: string) => {
    if (editTag && editTag.id === itemId) {
      setEditTag(null);
    }
    setActivePanel(prevActivePanel => (prevActivePanel === itemId ? null : itemId));
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (editTag) {
      const updatedTag = { ...editTag, name: e.target.value };
      setEditTag(updatedTag);
    }
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (editTag) {
      const updatedTag = { ...editTag, description: e.target.value };
      setEditTag(updatedTag);
    }
  };

  const handleSaveEditing = () => {
    if(!editTag) return;

    if (!editTag.location) return;

    addNewTag(editTag.name, editTag.description, editTag.location, editTag.dataIds, editTag?.id);
    setTags(tags.map(tag => (tag.id === editTag.id ? editTag : tag)));
    setActivePanel(null);
    setEditTag(null);
  };
  
  const handleCancelEditing = () => {
    setActivePanel(null);
    setEditTag(null);
  };

  return (
    <>
      <TagContainer>
        <div className="tag_sections">
          <Card
            title={
              <Space>
                Tags
                <div>
                  <ReloadOutlined onClick={loadTags} />
                  <CloseCircleOutlined style={{ marginLeft: 10 }} onClick={() => { setActiveMenu(null) }}   />
                </div>
              </Space>
            }
            bordered={false}
            style={{ width: 350 }}
          >
            <Collapse
            activeKey={activePanel ? [activePanel] : []}
              accordion
            >
              {tags.map((item, index) => (
                <Panel
                  showArrow={false}
                  header={
                    <div>
                      <Space>
                        <p className="accordion_title">
                          <span className="accordian_number">{`${index + 1}.`}</span>
                          <span className="accordion_tag" onClick={!editTag ? () => { zoomToTag(item.id) } : undefined}>
                            {editTag?.id === item.id ? <Input value={editTag.name} onChange={handleNameChange} maxLength={50} /> : item.name}
                          </span>
                          <span onClick={() => handlePanelTitleClick(item.id)}>
                            {activePanel === item.id ? <KeyboardArrowUpIcon className="custom-up-icon" /> : <KeyboardArrowDownIcon className="custom-down-icon" />}
                          </span>
                        </p>
                        <div className="accordion_icon">
                          <EyeOutlined style={{ width: '18px', height: '18px' }} />
                          <DeleteOutlined
                            style={{ width: '18px', height: '18px' }}
                            onClick={() => {
                              handleDelete(item.id);
                            }}
                          />
                          <EditOutlined style={{ width: '18px', height: '18px' }}  onClick={() => handleEdit(item)} />
                        </div>
                      </Space>
                    </div>
                  }
                  key={item.id}
                >
                  <div className="content">
                  <p>{editTag?.id === item.id ? <Input value={editTag.description} onChange={handleDescriptionChange} /> : item.description}</p>
                  </div>
                  {editTag?.id === item.id && (
                    <div className="save-cancel-icons">
                      <ButtonAntd shape="circle" icon={<CheckCircleOutlined />} disabled={!Boolean(editTag?.name)} onClick={handleSaveEditing}/>
                      <ButtonAntd  shape="circle" icon={<CloseCircleOutlined />} onClick={handleCancelEditing} />
                    </div>
                  )}
                </Panel>
              ))}
            </Collapse>
            {!showNewTag && (
              <div className="new_tag">
                <Button
                  className="btn_tag"
                  icon={<PlusCircleOutlined />}
                  onClick={handleNewTag}
                >
                  New Tag
                </Button>
              </div>
            )}
            {
              showNewTag && <AddTag handleCancel={handleCancel} handleSave={handleSave}/>
            }
          </Card>
        </div>
      </TagContainer>
    </>
  );
}
